import Vue from "vue";
import Vuex from "vuex";
import { elearningStore } from "./elearningStore";
import {
  INITIALIZE_STORE,
  LOGIN_USER,
  LOGOUT_USER,
  REFRESH_ACCESS_TOKEN,
  SET_REDIRECT_URL,
  SET_IS_AUTHENTICATING,
} from "./mutation-types";
import jwt_decode from "jwt-decode";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userId: "",
    userInitials: "",
    fullName: "",
    profilePicture: "",
    accessToken: null as string | null,
    deviceToken: "",
    roles: [],
    universityName: "VICTORIA UNIVERSITY",
    logoImageUrl: require("../assets/img/vu-logo-with-words.png"),
    backgroundImage: require("../assets/img/login-img.jpg"),
    redirectUrl: null as string | null,
    isAuthenticating: true,
    isAlreadyShowingCheckForUpdatesDialog: false,
  },
  mutations: {
    [REFRESH_ACCESS_TOKEN]: (state, { accessToken }) => {
      try {
        //@ts-ignore
        var decoded: String = jwt_decode(accessToken);
        //@ts-ignore
        state.userId = decoded.user_id;
        //@ts-ignore
        state.profilePicture = decoded.pp;
        //@ts-ignore
        state.userInitials = decoded.ui;
        state.accessToken = accessToken;

        //@ts-ignore
        state.fullName = decoded.fn;

        //@ts-ignore
        state.roles = decoded.roles;
      } catch (error) {
        //Nothing to do
      }
    },
    [LOGIN_USER]: (state, { accessToken, fbDeviceToken }) => {
      //Save the Device Token as we need it for Single User Sessions
      state.deviceToken = fbDeviceToken;

      try {
        //@ts-ignore
        var decoded: String = jwt_decode(accessToken);
        //@ts-ignore
        state.userId = decoded.user_id;
        //@ts-ignore
        state.profilePicture = decoded.pp;
        //@ts-ignore
        state.userInitials = decoded.ui;
        state.accessToken = accessToken;
        //@ts-ignore
        state.fullName = decoded.fn;

        //@ts-ignore
        state.roles = decoded.roles;
      } catch (error) {
        //Nothing to do
      }

      localStorage.setItem("a-dt", fbDeviceToken);
    },
    [LOGOUT_USER]: (state) => {
      state.userId = "";
      state.accessToken = "";
      state.userInitials = "";
      state.profilePicture = "";
      state.deviceToken = "";
      localStorage.removeItem("a-dt");
    },
    [INITIALIZE_STORE]: (state) => {
      state.deviceToken = localStorage.getItem("a-dt") || "";
    },
    [SET_REDIRECT_URL]: (state, payload) => {
      state.redirectUrl = payload;
    },
    [SET_IS_AUTHENTICATING]: (state, payload) => {
      state.isAuthenticating = payload;
    },
  },
  getters: {
    isLoggedIn: (state) => {
      return !!state.userId;
    },

    isNonTeachingStaff: (state) => {
      //@ts-ignore
      return state.roles.includes("NON_TEACHING_STAFF");
    },

    // deviceToken: state => state.accessToken
  },
  plugins: [elearningStore],
  actions: {},
  modules: {},
});
